import { render } from "./LoadingScreen.vue?vue&type=template&id=1c189561&scoped=true"
const script = {}

import "./LoadingScreen.vue?vue&type=style&index=0&id=1c189561&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c189561"]])

export default __exports__